// GENERATED by scripts/generate-brand-colors.mjs — edit contracts/brand-colors.yaml instead.
// The family of each enum value (docs/BRANDING.md §3.6). How it renders is up to the component:
// badges use Mantine's `light` variant, except where the series' variant says `filled`.

import type { PublicationType, AdType, Status, TeamRole, SurfaceType, TrackSurface, Visibility, RelativeWind, ClimbCategory, WaypointType } from '@/api/dto'

export type BadgeFamily = 'indigo' | 'blue' | 'green' | 'red' | 'yellow' | 'orange' | 'grape' | 'teal' | 'gray'

export const PUBLICATION_TYPE_COLORS = {
  RIDE: 'blue',
  POST: 'grape',
  TRIP: 'teal',
} as const satisfies Record<PublicationType, BadgeFamily>

export const AD_TYPE_COLORS = {
  SALE: 'green',
  RENTAL: 'indigo',
  WANTED: 'orange',
} as const satisfies Record<AdType, BadgeFamily>

export const STATUS_COLORS = {
  DRAFT: 'gray',
  PUBLISHED: 'green',
  CANCELLED: 'red',
} as const satisfies Record<Status, BadgeFamily>

export const TEAM_ROLE_COLORS = {
  MEMBER: 'gray',
  ORGANIZER: 'blue',
  ADMIN: 'grape',
} as const satisfies Record<TeamRole, BadgeFamily>

export const SURFACE_TYPE_COLORS = {
  ROAD: 'gray',
  GRAVEL: 'orange',
  MTB: 'green',
  MIXED: 'teal',
} as const satisfies Record<SurfaceType, BadgeFamily>

export const TRACK_SURFACE_COLORS = {
  PAVED: 'gray',
  PAVED_ROUGH: 'yellow',
  GRAVEL: 'orange',
  DIRT: 'green',
  PATH: 'grape',
  UNKNOWN: 'gray',
  OFF_NETWORK: 'gray',
} as const satisfies Record<TrackSurface, BadgeFamily>

export const VISIBILITY_COLORS = {
  TEAM: 'gray',
  PUBLIC_UNLISTED: 'orange',
  PUBLIC: 'blue',
} as const satisfies Record<Visibility, BadgeFamily>

export const RELATIVE_WIND_COLORS = {
  HEAD: 'orange',
  CROSS: 'gray',
  TAIL: 'teal',
} as const satisfies Record<RelativeWind, BadgeFamily>

export const CLIMB_CATEGORY_COLORS = {
  HC: 'grape',
  CAT1: 'red',
  CAT2: 'orange',
  CAT3: 'yellow',
  CAT4: 'green',
} as const satisfies Record<ClimbCategory, BadgeFamily>

export const WAYPOINT_TYPE_COLORS = {
  REGROUP: 'indigo',
  SUPPLY: 'orange',
  WATER: 'blue',
  CAFE: 'orange',
  TOILETS: 'gray',
  DANGER: 'red',
  SUMMIT: 'grape',
  VIEWPOINT: 'teal',
  BIKE_SHOP: 'gray',
  REAL_START: 'green',
  SPLIT: 'yellow',
  INFO: 'gray',
} as const satisfies Record<WaypointType, BadgeFamily>

/** The Mantine badge variant of each series. */
export const BADGE_VARIANTS = {
  PublicationType: 'light',
  AdType: 'light',
  Status: 'light',
  TeamRole: 'light',
  SurfaceType: 'light',
  TrackSurface: 'light',
  Visibility: 'light',
  RelativeWind: 'light',
  ClimbCategory: 'filled',
  WaypointType: 'filled',
} as const

/** Background of a card without a picture, 135° (top left → bottom right). */
export const FALLBACK_GRADIENTS = {
  RIDE: 'linear-gradient(135deg, var(--mantine-color-blue-6) 0%, var(--mantine-color-cyan-5) 100%)',
  POST: 'linear-gradient(135deg, var(--mantine-color-grape-6) 0%, var(--mantine-color-pink-5) 100%)',
  TRIP: 'linear-gradient(135deg, var(--mantine-color-teal-6) 0%, var(--mantine-color-green-5) 100%)',
  TEAM: 'linear-gradient(135deg, var(--mantine-color-violet-6) 0%, var(--mantine-color-indigo-5) 100%)',
  AD: 'linear-gradient(135deg, var(--mantine-color-orange-5) 0%, var(--mantine-color-yellow-4) 100%)',
} as const
